/**
 * Read-only auto-populated variables from plan metadata.
 *
 * @param {object} props
 * @param {object} props.autoPopulated
 * @returns {import('react').JSX.Element}
 */
const AutoPopulatedVariables = ({ autoPopulated }) => (
    <section className="plan-notification-panel plan-notification-panel--auto">
        <h2 className="plan-notification-panel__title">Auto populated variables</h2>
        <p className="plan-notification-field__helper">
            You cannot edit these inputs in this section. If these require editing,
            go back to the plan configuration and make these changes in the original
            fields.
        </p>

        <div className="form-input">
            <label htmlFor="plan-name">Plan name</label>
            <input id="plan-name" type="text" value={autoPopulated.planName} disabled />
            <p className="plan-notification-field__helper">
                This is the external plan name that should match what&apos;s being used in all member communications (not what is in Javelina)
            </p>
        </div>

        <div className="form-input">
            <label htmlFor="phone-member-services">Contact us phone number</label>
            <input
                id="phone-member-services"
                type="text"
                value={autoPopulated.phoneNumberMemberServices}
                disabled
            />
            <p className="plan-notification-field__helper">
                This is the client specific member support number.
            </p>
        </div>

        <div className="form-input">
            <label htmlFor="support-hours">Member care hours</label>
            <input
                id="support-hours"
                type="text"
                value={autoPopulated.supportHours}
                disabled
            />
            <p className="plan-notification-field__helper">
                These are the hours that the member support team is available, displayed in the client&apos;s local time zone.
            </p>
        </div>

        <div className="form-input">
            <label htmlFor="text-code">Text code</label>
            <input id="text-code" type="text" value={autoPopulated.textCode} disabled />
            <p className="plan-notification-field__helper">
                5-digit code that members will text to download the app.
            </p>
        </div>

        <div className="form-input">
            <label htmlFor="text-word">Text word</label>
            <input id="text-word" type="text" value={autoPopulated.textWord} disabled />
            <p className="plan-notification-field__helper">
                The key word that members will text to the &quot;Text code&quot; to receive the correct app download link.
            </p>
        </div>

        <div className="form-input">
            <label htmlFor="portal-url">URL</label>
            <input id="portal-url" type="text" value={autoPopulated.portalUrl} disabled />
            <p className="plan-notification-field__helper">
                This is the member portal URL, to be included in communications.
            </p>
        </div>
    </section>
);

export default AutoPopulatedVariables;
